import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "bistroquet_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((wine, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.wine.id === wine.id);
      if (found) {
        return prev.map((i) => (i.wine.id === wine.id ? { ...i, qty: i.qty + qty } : i));
      }
      return [...prev, { wine, qty }];
    });
  }, []);

  const setQty = useCallback((wineId, qty) => {
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.wine.id !== wineId) : prev.map((i) => (i.wine.id === wineId ? { ...i, qty } : i)),
    );
  }, []);

  const remove = useCallback((wineId) => {
    setItems((prev) => prev.filter((i) => i.wine.id !== wineId));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const { total, count } = useMemo(() => {
    return {
      total: items.reduce((sum, i) => sum + i.wine.price * i.qty, 0),
      count: items.reduce((sum, i) => sum + i.qty, 0),
    };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
